/** The search input's placeholder when the consumer gives none: Explore's filter menu copy. */
export const DEFAULT_SEARCH_PLACEHOLDER = "Search filter";
